import React from 'react'
import { useQuery } from 'urql'
import { GET_COMPANY_STATS } from '../../graphql/companies'
import { GET_USER_STATS } from '../../graphql/users'

// Iconos SVG
const Icons = {
  building: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect>
      <path d="M9 22v-4h6v4"></path>
      <path d="M8 6h.01"></path>
      <path d="M16 6h.01"></path>
      <path d="M12 6h.01"></path>
      <path d="M12 10h.01"></path>
      <path d="M12 14h.01"></path>
      <path d="M16 10h.01"></path>
      <path d="M16 14h.01"></path>
      <path d="M8 10h.01"></path>
      <path d="M8 14h.01"></path>
    </svg>
  ),
  checkCircle: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
      <polyline points="22 4 12 14.01 9 11.01"></polyline>
    </svg>
  ),
  circle: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
      <circle cx="12" cy="12" r="8"></circle>
    </svg>
  ),
  alertCircle: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="8" x2="12" y2="12"></line>
      <line x1="12" y1="16" x2="12.01" y2="16"></line>
    </svg>
  ),
  ban: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>
    </svg>
  ),
  users: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
      <circle cx="9" cy="7" r="4"></circle>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
    </svg>
  ),
  userCheck: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
      <circle cx="8.5" cy="7" r="4"></circle>
      <polyline points="17 11 19 13 23 9"></polyline>
    </svg>
  ),
  userX: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
      <circle cx="8.5" cy="7" r="4"></circle>
      <line x1="18" y1="8" x2="23" y2="13"></line>
      <line x1="23" y1="8" x2="18" y2="13"></line>
    </svg>
  ),
  shield: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
    </svg>
  ),
  handshake: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.42 4.58a5.4 5.4 0 0 0-7.65 0l-.77.78-.77-.78a5.4 5.4 0 0 0-7.65 0C1.46 6.7 1.33 10.28 4 13l8 8 8-8c2.67-2.72 2.54-6.3.42-8.42z"></path>
    </svg>
  ),
  user: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
      <circle cx="12" cy="7" r="4"></circle>
    </svg>
  )
}

function StatItem({ icon, color, value, label }) {
  return (
    <div className="stat-item">
      <div className={`stat-icon-wrapper ${color}`}>
        {icon}
      </div>
      <div className="stat-info">
        <span className="stat-value">{value}</span>
        <span className="stat-label">{label}</span>
      </div>
    </div>
  )
}

export function DashboardHome({ onNavigate }) {
  const [companyStatsResult] = useQuery({ query: GET_COMPANY_STATS })
  const [userStatsResult] = useQuery({ query: GET_USER_STATS })

  const companyStats = companyStatsResult.data?.companyStats || {}
  const userStats = userStatsResult.data?.userStats || {}

  const isLoading = companyStatsResult.fetching || userStatsResult.fetching

  if (isLoading) {
    return (
      <div className="loading-spinner">
        <div className="spinner"></div>
      </div>
    )
  }

  return (
    <>
      <div className="page-header">
        <h1 className="page-title">Dashboard</h1>
        <p className="page-subtitle">Resumen general del sistema</p>
      </div>

      <div className="dashboard-grid">
        {/* Container Empresas */}
        <div className="dashboard-card" onClick={() => onNavigate('companies')} style={{ cursor: 'pointer' }}>
          <div className="dashboard-card-header">
            <h3 className="dashboard-card-title">Empresas</h3>
            <span className="dashboard-card-link">Ver todas →</span>
          </div>
          <div className="stats-container">
            <StatItem icon={Icons.building} color="teal" value={companyStats.totalCompanies || 0} label="Total" />
            <StatItem icon={Icons.checkCircle} color="green" value={companyStats.activeCompanies || 0} label="Activas" />
            <StatItem icon={Icons.circle} color="green" value={companyStats.normalStatus || 0} label="Normal" />
            <StatItem icon={Icons.alertCircle} color="yellow" value={companyStats.rojoStatus || 0} label="Estado Rojo" />
            <StatItem icon={Icons.ban} color="red" value={companyStats.bloqueadoStatus || 0} label="Bloqueadas" />
            <div className="stat-item-empty"></div>
          </div>
        </div>

        {/* Container Usuarios */}
        <div className="dashboard-card" onClick={() => onNavigate('users')} style={{ cursor: 'pointer' }}>
          <div className="dashboard-card-header">
            <h3 className="dashboard-card-title">Usuarios</h3>
            <span className="dashboard-card-link">Ver todos →</span>
          </div>
          <div className="stats-container">
            <StatItem icon={Icons.users} color="teal" value={userStats.totalUsers || 0} label="Total" />
            <StatItem icon={Icons.userCheck} color="green" value={userStats.activeUsers || 0} label="Activos" />
            <StatItem icon={Icons.userX} color="red" value={userStats.deactivatedUsers || 0} label="Desactivados" />
            <StatItem icon={Icons.shield} color="purple" value={userStats.adminUsers || 0} label="Admins" />
            <StatItem icon={Icons.handshake} color="orange" value={userStats.collaboratorUsers || 0} label="Colaboradores" />
            <StatItem icon={Icons.user} color="blue" value={userStats.regularUsers || 0} label="Usuarios" />
          </div>
        </div>
      </div>
    </>
  )
}

export default DashboardHome
